import React, {Dispatch, SetStateAction, useCallback, useContext, useEffect, useRef} from "react"
import Slider from "../slider/Slider"
import {useRouter} from "next/router"
import {filterUrl} from "./FilterUrl"
import {CollectionName} from "../../constants"
import urlParams from "../../utility/UrlParams"
import DataContext from "../../context/DataContext"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"

type Props = {
    param: string
    range: string
    inputLabel?: string
    shouldUseZero?: boolean
    value: number
    setValue: Dispatch<SetStateAction<number | null>>
    collectionName:CollectionName
}
function ReusableRangeFilter({range, param, value, setValue, collectionName, inputLabel}: Props) {
	const prevValue = useRef(0)
	const router = useRouter()
	const {t} = useTranslation()
	const {brandWorld} = useContext(DataContext)
	const isBrandWorld = router.pathname.includes("/brand-world")
	const defaultValue = router.query?.[param]
	const min = Number(range.split("-")[0])
	const max = Number(range.split("-")[1])
	const setDefaut = useCallback(() => setValue(Number(defaultValue || 0)), [defaultValue])
	setDefaut()
	useEffect(() => {
		if (prevValue.current !== value && defaultValue) {
			const url = isBrandWorld ? `${filterUrl({...router.query, [param]: value}, param, value, CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing` : `${filterUrl({...router.query, [param]: value}, param, value, collectionName, collectionName)}`

			setValue(previousValue => {
				prevValue.current = previousValue
				return value
			})
			router.push(url, undefined, {shallow: true, scroll: false})
		}
	}, [value])
	return (
		<div className="position-relative  py-4">
			<div className="col-md-6 col-12 mb-4">
				<Typography variant="bodySm"
					semanticTag="h4"
					style={{color: "#6C7074"}}>{t(inputLabel)}</Typography>
				<input
					type="number"
					className="w-100"
					style={{border: "1px solid #dee2e6", borderRadius: "4px", padding: "10px 16px", height: "40px"}}
					value={value.toFixed()}
					onChange={e => {
						if (e.target.value) {
							setValue(Number(e.target.value))
						}
					}} />
			</div>
			<div className="col-12">
				<Typography style={{bottom: "3rem"}}
					className="position-absolute start-0 "
					variant="bodySm">{min}</Typography>
				<Typography style={{bottom: "3rem"}}
					className="position-absolute end-0 "
					variant="bodySm">{max}</Typography>
			</div>
			<Slider
				min={min}
				max={max}
				hasPriceTooltip
				defaultValue={value}
				onAfterChange={newValue => setValue(newValue)} />
		</div>
	)
}

export default ReusableRangeFilter
